import { DeliverableItem } from "./data-upload-review";

export const filterSDTMDeliverables = (deliverables: any) => {
  if (deliverables === undefined) return [];

  const filteredValues = Object.entries(deliverables)
    .filter(([_, value]) => (value as { checked: boolean }).checked === true)
    .map(([filename, value]) => {
      const { comment } = value as { checked: boolean; comment: string };
      return { filename, comment };
    });
  return filteredValues;
};

export const convertSDTM = (arr: any): Record<string, any> => {
  if (!Array.isArray(arr)) {
    return {};
  }

  return arr.reduce((acc: any, item: any) => {
    acc[item.filename] = {
      checked: true,
      comment: item.comment,
    };
    return acc;
  }, {});
};

export const hasCheckedDeliverable = (deliverables: any) => {
  if (deliverables === undefined) return false;

  return (Object.entries(deliverables) as [string, DeliverableItem][]).some(
    ([_, value]) => value.checked,
  );
};

export const updateDeliverablesWithDescription = (
  SDTMDeliverables: any,
  descriptionList: any,
) => {
  return SDTMDeliverables
    ? SDTMDeliverables.map((deliverable: any) => {
        const matchedObject = Array.isArray(descriptionList)
          ? descriptionList.find(
              (file: any) =>
                (file.fileName || file.filename) === deliverable.filename,
            )
          : null;
        return {
          ...deliverable,
          description: matchedObject ? matchedObject.description : null,
        };
      })
    : [];
};

export const extractFileNamesFromZip = (buffer: ArrayBuffer): string[] => {
  const dataView = new DataView(buffer);
  const zipFileNames: string[] = [];
  let offset = 0;

  while (offset + 4 <= dataView.byteLength) {
    const signature = dataView.getUint32(offset, true);

    if (signature === 0x04034b50) {
      // Need at least 30 bytes for the fixed local file header
      if (offset + 30 > dataView.byteLength) break;

      const compressedSize = dataView.getUint32(offset + 18, true);
      const fileNameLength = dataView.getUint16(offset + 26, true);
      const extraFieldLength = dataView.getUint16(offset + 28, true);

      const fileNameBytes = new Uint8Array(buffer, offset + 30, fileNameLength);
      const fileName = Array.from(fileNameBytes).map((b) => String.fromCharCode(b)).join("");

      // Skip directory entries (names ending with '/')
      if (fileName && !fileName.endsWith("/")) {
        zipFileNames.push(fileName);
      }

      // Advance past header + file name + extra field + compressed data
      offset += 30 + fileNameLength + extraFieldLength + compressedSize;
    } else if (signature === 0x02014b50) {
      // Central directory header — no more local entries
      break;
    } else {
      offset++;
    }
  }

  return zipFileNames;
};
